__turbopack_context__.v({
  "Label": "ExperienceDatesInput-module-scss-module__HAfmHa__Label",
  "Switch": "ExperienceDatesInput-module-scss-module__HAfmHa__Switch",
  "Thumb": "ExperienceDatesInput-module-scss-module__HAfmHa__Thumb",
  "body": "ExperienceDatesInput-module-scss-module__HAfmHa__body",
  "root": "ExperienceDatesInput-module-scss-module__HAfmHa__root",
});
